<template>
  <transition name="modal-fade">
	<div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
	    <div class="modal-content border-0 pt-4 px-3">
	      <div class="modal-header border-0">
	      	<slot name="header">
		        <h3 class="modal-title text-gray mx-auto mb-3">Registration</h3>
		        <button v-if="elVisible" type="button" class="close" @click="close" aria-label="Close">
		          <span aria-hidden="true">&times;</span>
		        </button>
	        </slot>
	      </div>
	      <div class="modal-body py-0 px-4">
	        <slot name="body" />
				<input class="border border-gray form-control mb-3" type="text" placeholder="First Name">
				<input class="border border-gray form-control mb-3" type="text" placeholder="Last Name">
				<input class="border border-gray form-control mb-3" type="text" placeholder="Company Name">
				<input class="border border-gray form-control mb-3" type="text" placeholder="Email Address">
				<input class="border border-gray form-control mb-3" type="text" placeholder="State / Province">
				<input class="border border-gray form-control mb-3" type="text" placeholder="Country">
				<input id="phone" class="border border-gray form-control mb-0" type="text" placeholder="Phone">
	    	</slot>
	    	<slot />
	      </div>
	      <div class="modal-footer border-0 px-4">
			<slot name="footer">
				<button type="button" class="btn btn-lg btn-primary btn-block my-4" @click="close" aria-label="Close">
					Register
				</button>
			</slot>
	      </div>
	    </div>
	  </div>
	</div>
  </transition>
</template>

<script>
	export default {
		methods: {
			showThanks() {
				this.isModalVisible = true;
			},
			close(event) {
			  this.$emit('close');
			}
		},
		data: function () {
			return {
				elVisible: false,
				isThanksVisible: false,
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Modal.vue